<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn id="btn-adicionar" depressed rounded color="primary" @click="adicionar">
          <v-icon left>mdi-plus</v-icon>Adicionar 
        </v-btn>

        <v-btn icon id="btn-atualizar" @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn-atualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      <!-- </v-toolbar-items> -->
      <z-text-field-search 
        v-model="busca" 
        select 
        class="ml-5" 
        @keydown.enter="buscar" 
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Lista de variacoes</h3>

      <v-card>

        <v-data-table
          :headers="headers"
          :items="variacoes"
          item-key="id"
          :loading="false"
          :search="search"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
        >
          <template v-slot:item="{ item: variacao }">
            <tr>
              <td>{{ variacao.id }}</td>
              <td>
                <span class="mr-2">{{ variacao.descricao }}</span>
              </td>
              <td>
                <v-chip 
                  v-for="(valor, index) in variacao.valores"
                  class="mr-2"
                  x-small 
                  color="grey lighten-2"
                  :key="index"
                >{{valor.descricao}}</v-chip>
              </td>
              <td class="text-center">
                <v-btn title="Editar" icon @click="editar(variacao)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn title="Excluir" icon @click="perguntarExcluir(variacao)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoRemoverVariacao"
      titulo="Remover variação?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      A variação <b>{{ variacao.descricao }}</b> será removida.
    </z-dialogo-sim-nao>

    <variacoes-form ref="dialogoVariacoesForm"></variacoes-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import VariacoesForm from "./VariacoesForm";

export default {
  name: "VariacoesLista",
  components: {
    VariacoesForm,
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "100px" },
        { text: "Variação", value: "descricao" },
        { text: "Valores", value: "varicao.valores", sortable: false },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      excluindo: false,
      variacao: {},
    };
  },

  created() {
    this.setTitulo("Cadastro de Variações");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("variacoes", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erroSistema("Não foi possível obter a lista de variações.");
        throw error;
      } finally {
        this.LOADING_OFF();
      }
    },

    adicionar() {
      this.$store.commit("variacoes/ZERAR");
      this.$refs.dialogoVariacoesForm.abrir();
    },

    async editar(variacao) {
      try {
        await this.abrir(variacao.id);
        this.$refs.dialogoVariacoesForm.abrir();
      } catch (error) {
        this.$eventbus.notificar("Não foi possível editar o variacao.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(variacao) {
      this.variacao = variacao;
      this.$refs.dialogoRemoverVariacao.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir();
        }
      });
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.variacao.id);
        this.$refs.dialogoRemoverVariacao.fechar();
        this.$eventbus.notificar("variacao excluído com sucesso!");
      } catch (error) {
        if (error.response) {
          this.$eventbus.erroSistema(error?.response?.data?.message);
        } else {
          this.$eventbus.erroSistema("Não foi possível excluir variacao!");
        }
      } finally {
        this.excluindo = false;
      }
    },

    limparBusca() {
      this.search = "";
      this.$store.commit("variacoes/SET_PAGE", 1);
      this.refresh();
    },
  },

  computed: {
    ...mapState("variacoes", ["variacoes", "pagination", "total_de_registros"]),

    search: {
      get() {
        return this.$store.state.variacoes.search;
      },
      set(search) {
        this.$store.commit("variacoes/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.variacoes.pagination;
      },
      set(options) {
        this.$store.commit("variacoes/UPDATE_PAGINATION", options);
      },
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
